import { defineStore } from "pinia";
import axios from "axios";
import { useAuthStore } from "./authStore";

export const useStatsStore = defineStore("statsStore", {
    state: () => {
        return {

        };
    },
    actions: {
        /**
         * Sends a request to the server to get the colors, which are used in the tickets currently.
         * @returns an array of the quantity of colors which are used. (Index corresponds to the index in printingMaterials)
         */
        async getColorsUsed() {
            const responseObject = await axios.get(`${process.env.VUE_APP_API_URL}/database/stats/colors_in_use`, {
                headers: {
                    Authorization: `Bearer ${useAuthStore().sessiontoken}`
                }
            })
            const colorsUsed = responseObject.data.color_usage;
            return colorsUsed;
        },
        async getColorsOverTime() {
            const responseObject = await axios.get(`${process.env.VUE_APP_API_URL}/database/stats/colors_over_time`,
                {
                    headers: {
                        Authorization: `Bearer ${useAuthStore().sessiontoken}`
                    }
                }
            );
            const colorsOverTime = responseObject.data;
            return colorsOverTime;
        }
    },

});